import Layout from "@/layout/views/index";
const projectManagement = [
  {
    path: "/project",
    component: resolve =>
      require(["@/project-management/views/index.vue"], resolve),
    name: "account",
    meta: {
      title: "项目管理",
      affix: true
    }
  },
  {
    path: "/project/databaseList",
    component: resolve =>
      require(["@/project-management/views/databaseList.vue"], resolve),
    name: "account",
    meta: {
      title: "数据表管理",
      affix: true
    }
  },
  {
    path: "/project/databaseList/databaseInfo",
    component: resolve =>
      require(["@/project-management/views/databaseInfo.vue"], resolve),
    name: "account",
    meta: {
      title: "字段编辑",
      affix: true
    }
  }
];
export default projectManagement;
